import { isEmptyObject } from '@/utils/helpers';
import { safeJsonLdStringify } from '@/utils/schema';

type StructuredDataProps = {
  structuredData?: object;
};

export const StructuredData = ({ structuredData }: StructuredDataProps) =>
  structuredData && !isEmptyObject(structuredData) ? (
    <script dangerouslySetInnerHTML={{ __html: safeJsonLdStringify(structuredData) }} type="application/ld+json" />
  ) : null;
